import React from 'react';

function Terms() {
  return (
    <div className="min-h-screen">
      <div className="max-w-4xl mx-auto px-4 py-32">
        <h1 className="text-4xl font-bold text-white mb-8">Terms of Service</h1>
        
        <div className="space-y-8 text-white/80">
          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">Agreement to Terms</h2>
            <p className="mb-4">
              By accessing or using Atlas AI's services, you agree to be bound by these Terms of Service. If you disagree with any part of the terms, you may not access our services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">Service Usage</h2>
            <p className="mb-4">
              Our services are provided "as is" and "as available." We reserve the right to modify, suspend, or discontinue any part of our services without notice at any time.
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Users must not misuse our services or help anyone else do so</li>
              <li>Users are responsible for maintaining the security of their account</li>
              <li>Services must be used in accordance with applicable laws and regulations</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">Intellectual Property</h2>
            <p className="mb-4">
              The service and its original content, features, and functionality are owned by Atlas AI and are protected by international copyright, trademark, patent, trade secret, and other intellectual property laws.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">User Content</h2>
            <p className="mb-4">
              Users retain their rights to any content they submit, post, or display on or through our services. By submitting content, users grant Atlas AI a worldwide, non-exclusive, royalty-free license to use, reproduce, modify, and distribute that content.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">Limitation of Liability</h2>
            <p className="mb-4">
              Atlas AI shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of or inability to use the service.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">Governing Law</h2>
            <p>
              These Terms shall be governed by and construed in accordance with the laws of the jurisdiction in which Atlas AI operates, without regard to its conflict of law provisions.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default Terms;